import { createSelector } from '@reduxjs/toolkit';

import { useReduxSelector } from '../../../hooks';

import { listingLayoutSelector } from './root';

export const listingLayoutIsNarrowSelector = createSelector(listingLayoutSelector, state => state.isNarrow);

export function useListingLayoutIsNarrowSelector(): boolean {
  return useReduxSelector(listingLayoutIsNarrowSelector);
}

export const listingLayoutFiltersHeightSelector = createSelector(listingLayoutSelector, state => state.filtersHeight);

export function useListingLayoutFiltersHeightSelector(): number {
  return useReduxSelector(listingLayoutFiltersHeightSelector);
}
